import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { useModalService } from "./../../../ricos-modals/index.js";
import { DropdownModal } from "./../../../_shared/dropdown-modal/dropdown-modal.js";
import { ListItemSelect } from "./../../../_shared/list-item-select/list-item-select.js";
import { dividerStyleData } from "../buttons/dividerButtonsData.js";
const LineStylePanel = ({ toolbarItem, modalId }) => {
  const modalService = useModalService();
  const { isMobile, t } = useContext(RicosContext);
  const getSelectedStyle = () => toolbarItem?.attributes.nodeStyle || "SINGLE";
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      onCloseButtonClick: () => modalService.closeModal(modalId),
      title: t("DividerPlugin_SelectType_Tooltip"),
      options: dividerStyleData.map(
        ({ dataHook, icon: Icon, iconSmall: IconSmall, commandKey, text }) => /* @__PURE__ */ React.createElement(
          ListItemSelect,
          {
            key: commandKey,
            dataHook,
            prefix: isMobile ? /* @__PURE__ */ React.createElement(Icon, null) : /* @__PURE__ */ React.createElement(IconSmall, null),
            selected: commandKey === getSelectedStyle(),
            onSelect: () => {
              toolbarItem.commands?.click({ value: commandKey });
              modalService.closeModal(modalId);
            },
            title: t(text)
          }
        )
      )
    }
  );
};
var LineStylePanel_default = LineStylePanel;
export {
  LineStylePanel_default as default
};
//# sourceMappingURL=LineStylePanel.js.map
